import SignalCellular1BarSharpIcon from "@mui/icons-material/SignalCellular1BarSharp";
import SignalCellular2BarSharpIcon from "@mui/icons-material/SignalCellular2BarSharp";
import SignalCellular3BarSharpIcon from "@mui/icons-material/SignalCellular3BarSharp";
import SignalCellular4BarSharpIcon from "@mui/icons-material/SignalCellular4BarSharp";

const SocialRating = ({ value }) => {
  if (value == 0) {
    return (
      <SignalCellular4BarSharpIcon color="disabled" sx={{ scale: "0.8" }} />
    );
  } else if (value < 1) {
    return <SignalCellular1BarSharpIcon color="error" sx={{ scale: "0.8" }} />;
  } else if (value < 10) {
    return (
      <SignalCellular2BarSharpIcon color="warning" sx={{ scale: "0.8" }} />
    );
  } else if (value < 50) {
    return (
      <SignalCellular3BarSharpIcon color="success" sx={{ scale: "0.8" }} />
    );
  } else {
    return (
      <SignalCellular4BarSharpIcon
        disableFocusRipple
        disableRipple
        color="success"
        sx={{ scale: "0.8" }}
      />
    );
  }
};

export default SocialRating;
